import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

const CustomContainer = ({ children, title, siteConfig }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: { xs: "auto", sm: "100vh" },
      }}
    >
      <Box
        sx={{
          borderRadius: "28px",
          width: "450px",
          padding: "32px",
          height: { xs: "100vh", sm: "auto" },
          backgroundColor:
            siteConfig.smallContainerBackgroundColor || "#f6f7fb",
        }}
      >
        {siteConfig.companyLogo && (
          <Box sx={{ display: "flex", justifyContent: "center", pb: 3 }}>
            <img
              src={siteConfig.companyLogo}
              alt="Logo"
              style={{ maxWidth: "200px", width: "100%" }}
            />
          </Box>
        )}

        <Typography
          variant="h2"
          sx={{
            mb: "12px",
            mt: 0,
            color: siteConfig.smallContainerTitleColor,
            fontSize: {
              xs: "2rem",
              sm: "2.3rem",
            },
          }}
        >
          {title}
        </Typography>
        {children}
      </Box>
    </Box>
  );
};

export default CustomContainer;
